<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <!-- <topPiece></topPiece> -->
      <div class="partner_wrap container">
        <titleConfig
          v-if="false"
          class="partner_h2"
          :title="langSet == 'cn' ? '新闻中心' : 'News Center'"
          :type="2"
        ></titleConfig>
        <newTitle
          :title="langSet === 'cn' ? '新闻中心' : 'News Center'"
        ></newTitle>
        <news
          class="news_item"
          :type="2"
          v-for="(item, index) in list"
          :key="index"
          :newsData="item"
        ></news>
        <nodata v-if="list.length == 0"></nodata>
        <div class="page_wrap flex flex_content_center">
          <el-pagination
            v-if="totals > 0"
            background
            :page-size="pageSize"
            :page-sizes="[5, 10, 15, 20, 30, 40, 50, 100]"
            layout="prev, pager, next, sizes"
            :total="totals"
            @current-change="currentChange"
            @size-change="sizeChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import newTitle from "@/components/new_title.vue";
// import topPiece from "@/components/topPiece.vue";
import news from "@/components/news.vue";
import nodata from "@/components/nodata.vue";
import { articleList } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    newTitle,
    titleConfig,
    //topPiece,
    news,
    nodata,
  },
  data() {
    return {
      langSet: "",
      list: [],
      totals: 0,
      pageNo: 1,
      pageSize: 5,
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    //25.6.9 获取新闻资讯 dxm
    this.pageNo = 1;
    this.pageSize = 5;
    this.getList();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getList() {
      let data = {
        page_no: this.pageNo,
        page_size: this.pageSize,
        lang: this.langSet,
      };
      const res = await articleList(data);
      this.list = res.data.lists;
      this.totals = res.data.count;
    },
    currentChange(e) {
      this.pageNo = e;
      this.getList();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.getList();
    },
  },
};
</script>
<style lang="scss" >
.page_wrap {
  padding: 60px 0 100px;
}
</style>
<style lang="scss" scoped>
@media only screen and (max-width: 767px) {
}
</style>